"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSystemInfo = getSystemInfo;
exports.buildResultNodes = buildResultNodes;
exports.toggleNode = toggleNode;
exports.compareResult = compareResult;
// import * as Types from "./types";
const GraphQlRequest = __importStar(require("@genesys/graphql-request"));
const property_1 = require("@genesys/property");
const product_properties_1 = require("@genesys/shared/lib/product-properties");
const uom_1 = require("@genesys/uom");
const ts_exhaustive_check_1 = require("ts-exhaustive-check");
const uuid_1 = require("uuid");
const queries_1 = require("./queries");
async function getSystemInfo(genesysNo, graphqlEndpoint, authorization) {
    const systemFileIdResult = await GraphQlRequest.request(queries_1.nevadaGenesysNoToSystemFileIdQuery, { genesysNo: genesysNo }, false, graphqlEndpoint, authorization);
    return systemFileIdResult;
}
function buildResultNodes(compareResults, getFormat) {
    const resultNodes = compareResults.components.map((c) => {
        const name = `${c.name} (${c.productId})`;
        const refProperties = property_1.PropertyValueSet.fromString(c.properties.refSystem);
        const testProperties = property_1.PropertyValueSet.fromString(c.properties.testSystem);
        const allPropertyNames = property_1.PropertyValueSet.getPropertyNames(property_1.PropertyValueSet.merge(refProperties, testProperties));
        const refSpecifications = property_1.PropertyValueSet.fromString(c.specifications.refSystem);
        const testSpecifications = property_1.PropertyValueSet.fromString(c.specifications.testSystem);
        const allSpecs = property_1.PropertyValueSet.getPropertyNames(property_1.PropertyValueSet.merge(refSpecifications, testSpecifications));
        const specifications = allSpecs.map((x) => {
            const formatter = (quantity) => getFormat("", x, quantity);
            const stringifyValues = (property) => {
                return stringifyPropertyValue(property, formatter);
            };
            const refSpec = property_1.PropertyValueSet.get(x, refSpecifications);
            const testSpec = property_1.PropertyValueSet.get(x, testSpecifications);
            const leaf = {
                type: "leaf",
                ok: (!refSpec && !testSpec) ||
                    !!(refSpec && testSpec && property_1.PropertyValue.equals(refSpec, testSpec)),
                ref: refSpec,
                test: testSpec,
                formatter,
                stringifyValues
            };
            return {
                type: "node",
                id: (0, uuid_1.v4)(),
                name: x,
                expanded: false,
                children: [leaf],
                ok: leaf.ok
            };
        });
        const properties = allPropertyNames.map((n) => {
            const fieldGroup = "Settings." + c.productId;
            const fieldName = n;
            const formatter = (quantity) => getFormat(fieldGroup, fieldName, quantity);
            const refProperty = property_1.PropertyValueSet.get(n, refProperties);
            const testProperty = property_1.PropertyValueSet.get(n, testProperties);
            const stringifyValues = (property) => {
                return stringifyPropertyValue(property, formatter);
            };
            const leaf = {
                type: "leaf",
                ok: (!refProperty && !testProperty) ||
                    !!(refProperty &&
                        testProperty &&
                        property_1.PropertyValue.equals(refProperty, testProperty)),
                ref: refProperty,
                test: testProperty,
                formatter,
                stringifyValues
            };
            return {
                type: "node",
                id: (0, uuid_1.v4)(),
                name: n,
                expanded: false,
                children: [leaf],
                ok: leaf.ok
            };
        });
        const propertyNode = {
            type: "node",
            id: (0, uuid_1.v4)(),
            name: "Properties",
            expanded: false,
            children: properties,
            ok: properties.every((p) => p.ok)
        };
        const specificationNode = {
            type: "node",
            id: (0, uuid_1.v4)(),
            name: "Specifications",
            expanded: false,
            children: specifications,
            ok: specifications.every((p) => p.ok)
        };
        const priceLeafer = (p) => ({
            type: "leaf",
            ref: property_1.PropertyValue.create("text", p.refSystem.toString()),
            test: property_1.PropertyValue.create("text", p.testSystem.toString()),
            formatter: () => 1,
            stringifyValues: (x) => x.value.toString(),
            ok: p.refSystem === p.testSystem
        });
        const priceNoder = (name, children) => ({
            type: "node",
            id: (0, uuid_1.v4)(),
            name: name,
            expanded: false,
            children: children,
            ok: children.every((c) => c.ok)
        });
        const priceNodes = c.price.map((p) => {
            return priceNoder(p.name, [priceLeafer(p)]);
        });
        const priceNode = {
            type: "node",
            id: (0, uuid_1.v4)(),
            name: "Price",
            expanded: false,
            children: priceNodes,
            ok: priceNodes.every((c) => c.ok)
        };
        const operatingCaseNodes = c.operatingCases.map((oc) => {
            const name = oc.name;
            const refResults = property_1.PropertyValueSet.fromString(oc.refSystem);
            const testResults = property_1.PropertyValueSet.fromString(oc.testSystem);
            const allPropertyNames = property_1.PropertyValueSet.getPropertyNames(property_1.PropertyValueSet.merge(refResults, testResults));
            const results = allPropertyNames.map((n) => {
                const split = n.split("_");
                const groupName = split[0];
                const fieldName = split[1];
                const formatter = (quantity) => getFormat(groupName, fieldName, quantity);
                const stringifyValues = (property) => {
                    return stringifyPropertyValue(property, formatter);
                };
                const refResult = property_1.PropertyValueSet.get(n, refResults);
                const testResult = property_1.PropertyValueSet.get(n, testResults);
                const leaf = {
                    type: "leaf",
                    ref: refResult,
                    test: testResult,
                    stringifyValues,
                    formatter,
                    ok: (!refResult && !testResult) ||
                        !!(refResult &&
                            testResult &&
                            property_1.PropertyValue.equals(refResult, testResult))
                };
                return {
                    type: "node",
                    id: (0, uuid_1.v4)(),
                    name: n,
                    expanded: false,
                    children: [leaf],
                    ok: leaf.ok
                };
            });
            return {
                type: "node",
                id: (0, uuid_1.v4)(),
                name: name,
                expanded: false,
                children: results,
                ok: results.every((r) => r.ok)
            };
        });
        const operatingCaseRootNode = {
            type: "node",
            id: (0, uuid_1.v4)(),
            name: "Operating cases",
            expanded: false,
            children: operatingCaseNodes,
            ok: operatingCaseNodes.every((oc) => oc.ok)
        };
        const componentChildren = [
            propertyNode,
            priceNode,
            operatingCaseRootNode,
            ...(!!specifications.length ? [specificationNode] : [])
        ];
        return {
            type: "node",
            id: (0, uuid_1.v4)(),
            name: name,
            expanded: false,
            children: componentChildren,
            ok: componentChildren.every((c) => c.ok)
        };
    });
    return resultNodes;
}
function toggleNode(node, path, depth) {
    const targetNodeId = path[path.length - 1];
    if (targetNodeId === node.id) {
        return Object.assign(Object.assign({}, node), { expanded: !node.expanded });
    }
    return Object.assign(Object.assign({}, node), { children: node.children.map((c) => c.type === "node" && c.id === path[depth + 1]
            ? toggleNode(c, path, depth + 1)
            : c) });
}
function compareResult(result, columns, name) {
    return result.nodes
        .filter((n) => !n.ok)
        .map((r) => visit(r, columns, name))
        .reduce((a, b) => [...a, ...b], []);
}
function getExcelCellValues(l, column, nodeName, unitName, refValue, testValue, diff, name) {
    switch (column) {
        case "name": {
            return name;
        }
        case "tags": {
            return nodeName;
        }
        case "unit": {
            return unitName || "";
        }
        case "ref": {
            return refValue || l.stringifyValues(l.ref);
        }
        case "test": {
            return testValue || l.stringifyValues(l.test);
        }
        case "diff": {
            // biome-ignore lint: -
            return !isNaN(parseInt(diff, 10)) ? diff + "%" : diff;
        }
        default:
            (0, ts_exhaustive_check_1.exhaustiveCheck)(column);
    }
}
function visit(node, columns, name) {
    if (node.children.some((c) => c.type === "leaf")) {
        const leaves = node.children.map((c) => c);
        return leaves.map((l) => {
            var _a, _b;
            let refFormat = undefined;
            let testFormat = undefined;
            let refValue = "";
            let testValue = "";
            if (((_a = l.ref) === null || _a === void 0 ? void 0 : _a.type) === "amount") {
                refFormat = l.formatter(l.ref.value.unit.quantity);
                refValue = (0, product_properties_1.getValue)(l.ref, refFormat);
            }
            if (((_b = l.test) === null || _b === void 0 ? void 0 : _b.type) === "amount") {
                testFormat = l.formatter(l.test.value.unit.quantity);
                testValue = (0, product_properties_1.getValue)(l.test, testFormat);
            }
            const unitName = (refFormat === null || refFormat === void 0 ? void 0 : refFormat.unit.name) === (testFormat === null || testFormat === void 0 ? void 0 : testFormat.unit.name)
                ? refFormat === null || refFormat === void 0 ? void 0 : refFormat.unit.name
                : "Units are diffrent";
            let diff = "";
            if (refValue && testValue) {
                diff = (((parseFloat(testValue) - parseFloat(refValue)) /
                    parseFloat(refValue)) *
                    100).toFixed(2);
            }
            return columns.map((col) => {
                return getExcelCellValues(l, col.columnName, node.name, unitName, refValue, testValue, diff, name);
            });
        });
    }
    return node.children
        .filter((c) => !c.ok)
        .map((c) => visit(c, columns, name))
        .reduce((a, b) => [...a, ...b], [["", node.name]]);
}
function stringifyPropertyValue(property, getFormat) {
    if (!property) {
        return "Undefined";
    }
    switch (property.type) {
        case "text":
        case "integer":
            return property_1.PropertyValue.toString(property);
        case "amount": {
            const format = getFormat(property.value.unit.quantity);
            const unitFormat = uom_1.Format.getUnitFormat(format.unit);
            if (!unitFormat) {
                throw new Error("Unknown unit format");
            }
            return (uom_1.Amount.valueAs(format.unit, property.value) +
                " " +
                unitFormat.label);
        }
        default:
            throw new Error("Unknown property type");
    }
}
//# sourceMappingURL=functions.js.map